import React from 'react'
import PropTypes from 'prop-types'
import Helmet from 'react-helmet'

import { Page, Section, Container } from '../components/common'
import Content from '../components/Content'
import Meta from '../components/Meta'
import Header from '../components/Header'

const InfoPage = ({ infoPage }) => {
  const { title, subtitle, content } = infoPage.fields
  return (
    <Page bgWhite>
      <Helmet title={title} />
      <Meta title={title} description={content} />

      <Header small title={title} subtitle={subtitle} />
      <Section>
        <Container>
          <Content source={content} />
        </Container>
      </Section>
    </Page>
  )
}

InfoPage.propTypes = {
  infoPage: PropTypes.object.isRequired
}

export default InfoPage



// WEBPACK FOOTER //
// ./src/views/InfoPage.js